export function normalizeCommentDeepLink(link) {
  if (!link) return '';

  const raw = link.startsWith('/') ? link : `/${link}`;
  const hashIndex = raw.indexOf('#');
  const withoutHash = hashIndex >= 0 ? raw.slice(0, hashIndex) : raw;
  const existingHash = hashIndex >= 0 ? raw.slice(hashIndex) : '';

  const queryIndex = withoutHash.indexOf('?');
  const pathname = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const queryString = queryIndex >= 0 ? withoutHash.slice(queryIndex + 1) : '';
  const params = new URLSearchParams(queryString);
  const commentId = params.get('comment');
  params.delete('comment');
  const remainingQuery = params.toString();

  let normalizedPath = pathname.replace(/^\/forum\/(\d+)$/, '/forum/detail/$1');

  let result = normalizedPath;
  if (remainingQuery) {
    result += `?${remainingQuery}`;
  }

  if (commentId) {
    result += `#comment-${commentId}`;
  } else if (existingHash.startsWith('#comment-')) {
    result += existingHash;
  }

  return result;
}

export function getCommentIdFromLocation(location) {
  const hash = location?.hash || '';
  if (hash.startsWith('#comment-')) {
    return hash.replace('#comment-', '');
  }

  const search = location?.search || '';
  if (search) {
    const commentId = new URLSearchParams(search).get('comment');
    if (commentId) return commentId;
  }

  return null;
}
